export enum ProviderType {
    sic = 'bdcsAndSic',
    sicBxl = 'sicbxl',
    bbc = 'bbc2020'
}
